import {
    createOptionPicker,
    IOptionPickerItem,
    OptionPicker,
    OptionPickerType,
} from '@vfde-brix/ws10/option-picker';

/**
 * Mount the option picker
 */
export const mountOptionPicker = (
    containerId: string,
    stdName: string,
    optType: OptionPickerType,
    items: IOptionPickerItem[],
    onChange: (Event: Event) => void,
): OptionPicker | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    return createOptionPicker(container, {
        stdName,
        optType,
        items,
        business: {
            onChange,
        },
    });
};

/**
 * Disables all optionPicker options and removes the optChecked state
 * @param optionPicker The option picker
 */
export const disableOptionPicker = (optionPicker: OptionPicker) => {
    optionPicker.clearValue();
    optionPicker.disableAllOptions();
};
